// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3e8yh","label":"Completed_label__3xJWH"};